
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings/[slug]",
      function () {
        return require("private-next-pages/listings/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listings/[slug]"])
      });
    }
  